import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5869cc2b&scoped=true&"
import script from "./Header.ts?vue&type=script&lang=ts&"
export * from "./Header.ts?vue&type=script&lang=ts&"
import style0 from "./Header.css?vue&type=style&index=0&id=5869cc2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5869cc2b",
  null
  
)

export default component.exports